import { Drawer_Content_default } from "./chunk-7Q4NBIHL.js";
import { Drawer_Header_default } from "./chunk-67CPSISG.js";
import { Drawer_default } from "./chunk-Y3KDUKPV.js";

// src/components/Drawer/index.ts
var DrawerComponent = Drawer_default;
DrawerComponent.Header = Drawer_Header_default;
DrawerComponent.Header.displayName = "Drawer.Header";
DrawerComponent.Content = Drawer_Content_default;
DrawerComponent.Content.displayName = "Drawer.Content";
export { DrawerComponent };